export const protocolAxes = [
  {
    id: 'identity',
    label: 'Identity',
    shortLabel: 'Identity',
    question: 'Do you follow any specific dietary identity?',
    description: 'Dietary identity',
    explanation:
      'Your dietary identity reflects religious, medical, or ethical constraints that form the foundation of your nutritional approach.',
    options: [
      {
        value: 'ahimsa',
        label: 'Ahimsa',
        description: 'Ahimsa',
      },
      {
        value: 'antihistamine',
        label: 'Anti-histamine',
        description: 'Anti-histamine',
      },
      {
        value: 'autoimmune',
        label: 'Autoimmune',
        description: 'Autoimmune',
      },
      {
        value: 'celiac',
        label: 'Celiac',
        description: 'Celiac',
      },
      {
        value: 'diabetic',
        label: 'Diabetic',
        description: 'Diabetic',
      },
      {
        value: 'fodmap',
        label: 'FODMAP',
        description: 'FODMAP',
      },
      {
        value: 'halal',
        label: 'Halal',
        description: 'Halal',
      },
      {
        value: 'kosher',
        label: 'Kosher',
        description: 'Kosher',
      },
      {
        value: 'renal',
        label: 'Renal',
        description: 'Renal',
      },
      {
        value: 'sattvic',
        label: 'Sattvic',
        description: 'Sattvic',
      },
      {
        value: 'standard',
        label: 'None',
        description: 'None',
      },
    ],
  },
  {
    id: 'mealFrequency',
    label: 'Meal Frequency',
    shortLabel: 'Timing',
    question: 'What meal frequency pattern do you prefer?',
    description: 'Meal timing',
    explanation:
      'Your eating frequency and timing affects metabolic function, hormone balance, and energy levels.',
    options: [
      {
        value: 'grazer',
        label: 'Grazer',
        description: '5-6 meals/day, evenly spaced',
      },
      {
        value: 'daystride',
        label: 'Daystride',
        description: '3 square meals/day, traditional eating times',
      },
      {
        value: 'sunfast',
        label: 'Sunfast',
        description: '16:8 or similar, time-restricted eating',
      },
      {
        value: 'nightbound',
        label: 'Nightbound',
        description: '1 meal per day, evening feast after long fast',
      },
    ],
  },
  {
    id: 'foodType',
    label: 'Food Type',
    shortLabel: 'Foods',
    question: 'What types of foods form the foundation of your diet?',
    description: 'Food identity',
    explanation:
      'Your primary food sources define both nutrition and identity aspects of your protocol.',
    options: [
      {
        value: 'beast',
        label: 'Beast',
        description: 'Carnivorous (animal protein only)',
      },
      {
        value: 'tide',
        label: 'Tide',
        description: 'Pescatarian (sea-based proteins + plants)',
      },
      {
        value: 'plant',
        label: 'Plant',
        description: 'Vegetarian (dairy/eggs optional)',
      },
      {
        value: 'fusion',
        label: 'Fusion',
        description: 'Omnivore (inclusive of all food groups)',
      },
    ],
  },
  {
    id: 'macroStrategy',
    label: 'Macronutrient Strategy',
    shortLabel: 'Macros',
    question: 'What macronutrient approach do you prefer?',
    description: 'Macronutrient emphasis',
    explanation:
      'Your macronutrient ratio affects energy systems, hormonal signals, and metabolic pathways.',
    options: [
      {
        value: 'burn',
        label: 'Burn',
        description: 'Low carb (high fat)',
      },
      {
        value: 'surge',
        label: 'Surge',
        description: 'Low fat (high carb)',
      },
      {
        value: 'flux',
        label: 'Flux',
        description: 'Balanced macros (30/30/40 or flexible)',
      },
      {
        value: 'whisper',
        label: 'Whisper',
        description: 'Low protein (high carb and/or high fat)',
      },
    ],
  },
  {
    id: 'microStrategy',
    label: 'Micronutrient Strategy',
    shortLabel: 'Micros',
    question: 'How do you prefer to source your micronutrients?',
    description: 'Micronutrient sourcing',
    explanation:
      'Micronutrients are essential for cellular function and overall health.',
    options: [
      {
        value: 'spice',
        label: 'Spice',
        description: 'Nutrient-dense herbs, seeds, and spices',
      },
      {
        value: 'brew',
        label: 'Brew',
        description: 'Nutrients through teas, broths, infusions',
      },
      {
        value: 'culture',
        label: 'Culture',
        description: 'Fermented foods, pre- and probiotics',
      },
      {
        value: 'marrow',
        label: 'Marrow',
        description: 'Animal organs, bones, and internal nutrients',
      },
      {
        value: 'elixir',
        label: 'Elixir',
        description: 'Energy drinks, protein shakes, pill supplementation',
      },
      {
        value: 'alloy',
        label: 'Alloy',
        description: 'Enriched foods, fortified foods',
      },
      {
        value: 'super',
        label: 'Super',
        description: 'superfoods, micro-rich whole ingredients',
      },
    ],
  },
  {
    id: 'feedingCycle',
    label: 'Feeding Cycle',
    shortLabel: 'Cycle',
    question: 'What feeding cycle protocol do you follow?',
    description: 'Feeding pattern',
    explanation:
      'Your feeding cycle affects metabolic rhythm, digestive recovery, and nutrient partitioning.',
    options: [
      {
        value: '180',
        label: '+/-',
        description: 'Seasonal bulk/cut',
      },
      {
        value: '3.4',
        label: '3/4',
        description: 'Alternating high/low carb days (e.g., 3-4/wk)',
      },
      {
        value: '6.1',
        label: '6/1',
        description: 'Refeed or cheat meals 1x/wk',
      },
      {
        value: '2.5',
        label: '2/5',
        description: '2 days normal, 5 days keto',
      },
      {
        value: '52',
        label: '5/2',
        description: '5 days eating, 2 fasting or low-cal',
      },
      {
        value: '7.0',
        label: '7/0',
        description: 'No specific feeding cycle',
      },
    ],
  },
  {
    id: 'exerciseTiming',
    label: 'Exercise-eating Timing',
    shortLabel: 'Exercise',
    question: 'How do you time your meals around exercise?',
    description: 'Exercise timing',
    explanation:
      'Meal timing relative to exercise affects performance, recovery, and nutrient partitioning.',
    options: [
      {
        value: 'emp',
        label: 'EMP',
        description: 'Empty-State: Fasted exercise (no food 3-12 hrs before)',
      },
      {
        value: 'prm',
        label: 'PRM',
        description: 'Primed-State: Small pre-workout meal 60-90 min before',
      },
      {
        value: 'fed',
        label: 'FED',
        description: 'Fed-State: Large/full meal within 60 mins before',
      },
      {
        value: 'pst',
        label: 'PST',
        description: 'Post-Fed: Meal immediately after exercise',
      },
      {
        value: 'ref',
        label: 'REF',
        description: 'Delayed-Refeed: Post-exercise meal 1-3 hrs later',
      },
      {
        value: 'bke',
        label: 'BKE',
        description: 'Bookend Eating: Meals only pre- and post-exercise',
      },
      {
        value: 'win',
        label: 'WIN',
        description:
          'Exer-Fed Window: Eating only during training-adjacent hours',
      },
      {
        value: 'none',
        label: 'None',
        description: 'No specific exercise timing strategy',
      },
    ],
  },
]

export const radarAxes = [
  {
    id: 'physical',
    label: 'Athletics',
    description:
      'Athletic performance, sleep quality, bone & joint integrity, cardiovascular integrity',
    metrics: '1RM, VO2-max, REM %, BMD, ApoB',
  },
  {
    id: 'bodyBalance',
    label: 'BodyComp',
    description: 'Body composition',
    metrics: 'DEXA %-fat, lean-mass index, waist/height ratio',
  },
  {
    id: 'metabolic',
    label: 'Metabolism',
    description: 'Metabolic efficiency',
    metrics: 'Fasting glucose, HOMA-IR, RER (fat-oxidation %)',
  },
  {
    id: 'longevity',
    label: 'Longevity',
    description: 'Longevity & health-span markers',
    metrics: 'DNAm age, telomere length, IGF-1 balance',
  },
  {
    id: 'emotional',
    label: 'Wellbeing',
    description: 'Stress regulation & mental resilience',
    metrics: 'HRV spread, daily stress score, mood-stability index',
  },
  {
    id: 'ease',
    label: 'Ease',
    description: 'Subjective ease & practicality',
    metrics: 'Prep time per day, cost index, "effort" rating',
  },
  {
    id: 'immune',
    label: 'Immunity',
    description: 'Immune resilience',
    metrics: 'hs-CRP, WBC differential, autoimmune flare index',
  },
  {
    id: 'digestive',
    label: 'Digestion',
    description: 'Digestive harmony',
    metrics: 'Bristol variance, bloating episodes, microbiome diversity',
  },
  {
    id: 'hormoneBalance',
    label: 'Hormones',
    description: 'Hormonal balance',
    metrics: 'Free T/E ratio, TSH, AM-PM cortisol delta',
  },
  {
    id: 'mental',
    label: 'Cognition',
    description: 'Cognitive function',
    metrics: 'Working-memory score, reaction time, focus duration',
  },
  {
    id: 'spiritual',
    label: 'CultureFit',
    description: 'Cultural / ethical alignment & ritual adherence',
    metrics: '% compliant meals, self-reported fulfillment',
  },
  {
    id: 'satiety',
    label: 'Satiety',
    description: 'Hunger & cravings control',
    metrics: 'Leptin/ghrelin ratio, hunger-event count',
  },
]
